import React from 'react';
import {Select} from '@bonprix/design-system';

const MAX_QUANTITY = 15;

export default function CartItemQuantitySelection({item, items, label, onChange, isCalculatingPrice}) {
    const changeQuantity = (value) => {
        const changeType = value > item.quantity ? 'INCREASE' : 'DECREASE';
        onChange(item, value, changeType, items);
    };

    const renderSelectItems = [];
    for (let i = 1; i <= MAX_QUANTITY; i++) {
        renderSelectItems.push(<Select.Item key={i} value={i}>{i}</Select.Item>);
    }

    if (item.quantity > MAX_QUANTITY) {
        renderSelectItems.push(
            <Select.Item
                key={'disable'}
                value={item.quantity}
                disabled={true}>
                {item.quantity}
            </Select.Item>
        );
    }

    return (
                <Select
                    id={'test-ref__cart-item-count'}
                    onValueChange={changeQuantity}
                    label={label}
                    disabled={isCalculatingPrice || !item.deliverable}
                    value={item.quantity}>
                    {renderSelectItems}
                </Select>
    );
}